module.exports = __webpack_public_path__ + "static/media/banner_evo-half.7fbb407a.webp";